import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import history from "features/history";
import { toggleShowOrderConfirmation } from "features/orders/orderConfirmationSlice";
import OrderConfirmation from "./OrderConfirmation";
import Loader from "components/Loader";

export default function OrderConfirmationModal() {
	const dispatch = useDispatch();
	// Selectors
	const { isLoading, isOpen, order, orderId } = useSelector(
		(state) => state.orderConfirmation
	);
	// Handlers
	function handleModalClose() {
		dispatch(toggleShowOrderConfirmation({ isOpen }));
		history.replace("/");
	}
	// Render functions
	function renderLoader() {
		if (isLoading) {
			return (
				<div className="order-main">
					<Loader msg="Cargando..." />
				</div>
			);
		}
	}
	function renderOrderConfirmation() {
		if (!isLoading) {
			return <OrderConfirmation />;
		}
		return null;
	}
	// Render
	if (!isLoading && (orderId == null || order == null)) {
		return null;
	}
	return (
		<div>
			<Modal
				isOpen={isOpen}
				className="modal"
				overlayClassName="modal-overlay"
				contentLabel="Carrito"
			>
				<div className="modal-inner" id="order-inner">
					<div className="modal-close" onClick={handleModalClose}></div>
					<div>
						<span className="logo-conti"></span>
					</div>
					<h2>Pedido ContiShop</h2>
					{renderLoader()}
					{renderOrderConfirmation()}
				</div>
			</Modal>
		</div>
	);
}
